import React, {useEffect, useState} from 'react';
import {Button, Checkbox, Form, Input, Flex, Progress} from 'antd';


function PaymentCardComponent ({record, index}) {
    let message = `You have gained a <span class="${record.expansion==='growth'?'text-green':'text-pink'} font-bold">${record.growth} ${record.expansion}</span> compared to ${record.unit}`;
    let progress = `<span class="font-bold">${record.percentage}%</span> of ${record.target} ${record.target_label} target`;
    return (
        <div key={`PaymentCardComponent-${index}`} className="flex flex-col xl:py-[25px] 2xl:py-[30px] mb-[12px] font-uregular rounded border-b-[1px] border-grey">
            <div className="text-2xl font-ubold mb-[8px] text-preblack">{`${record.amount} TK`}</div>
            <div className="text-sm mb-[8px] text-pregray">{record.label}</div>
            <div className="flex flex-row items-center mb-[8px]">
                <img className="w-[24px] h-[24px] mr-[12px]" src={`/images/${record.expansion==='growth'?'increase':'decrease'}.svg`}/>
                <div className="flex-grow text-sm text-pregray" dangerouslySetInnerHTML={{ __html: message }} />
            </div>
            <Progress className="mb-[8px]" strokeColor="#111111" percent={record.percentage} showInfo={false} />
            <div dangerouslySetInnerHTML={{__html: progress}}/>
        </div>
    );
}

export default PaymentCardComponent;
